import actionTypes from '../constants/action-types';

const setPagesInNavigation = (pageIds) => ({
  type: actionTypes.SET_PAGES_IN_NAVIGATION,
  payload: {
    pageIds,
  },
});

export default setPagesInNavigation;
